import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MobileNavigationMenuComponent } from '@platform/dashboard/components/mobile-navigation-menu/mobile-navigation-menu.component';
import { WelcomeModalComponent } from '@platform/dashboard/components/welcome-modal/welcome-modal.component';
import { NavigationHeaderComponent } from '@shared/components/navigation-header/navigation-header.component';
import { SidePanelNavigationComponent } from '@shared/components/side-panel-navigation/side-panel-navigation.component';
import { ErrorGuard } from '@shared/guards/error.guard';
import { PlatformComponent } from './platform.component';
import { platformRoutes } from './platform.routes';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    RouterModule.forChild(platformRoutes),
    NavigationHeaderComponent,
    MobileNavigationMenuComponent,
    WelcomeModalComponent,
    SidePanelNavigationComponent,
  ],
  declarations: [PlatformComponent],
  providers: [ErrorGuard],
})
export class PlatformModule {}
